// Rotte pubbliche accessibili a tutti gli utenti autenticati
// Queste rotte non richiedono permessi specifici nel routePermissionsMap

const publicRoutes = [
    '/',                    // Homepage
    '/demo',                // Pagina demo
    '/chat',                // Chat interna
    '/unauthorized',        // Pagina di accesso negato
    '/maintenance',         // Pagina di manutenzione
    '/risorseaziendali',    // Risorse aziendali
    '/gestione-alert-clienti', // Gestione alert clienti
];

// Prefissi di rotte pubbliche
const publicRoutePrefixes = [
    '/categoria/',          // Tutte le dashboard di categoria
    '/articoli/',           // Tutte le pagine articoli (con parametri dinamici)
];

/**
 * Verifica se una rotta è pubblica (accessibile a tutti gli utenti autenticati)
 * @param {string} path - Il path della rotta da verificare
 * @returns {boolean} - True se la rotta è pubblica
 */
export function isPublicRoute(path) {
    // Controlla se il path è nella lista delle rotte pubbliche
    if (publicRoutes.includes(path)) {
        return true;
    }
    
    // Controlla se il path inizia con uno dei prefissi pubblici
    return publicRoutePrefixes.some(prefix => path.startsWith(prefix));
}

export default publicRoutes;
